// class used to read all elements properties from a specific view

import { logError } from "./IAmecLog";
import { ElementModelId, modelIdToKey } from "./TemplatesAndCollections";
import { currentUser } from "./IUsers";

export class PropertiesManager {
    constructor() {
        this.properties = new Object();
        this.modelsMap = new Object(); // hold the source model for each object
        this.wbs = new Object();
        this.keyToId = new Object();
        this.idToAssignments = new Object(); // viewer id -> array of assignments
        this.viewerIdToModelId = new Object();
        this.modelIdToViewerId = new Object();
    }

    // viewer - forge viewer
    // ids - list of ids from the viewer open model to load properties from
    async loadElements(viewer, ids, projectId) {
        var loadedModelName = viewer.model
            .getData()
            .loadOptions.bubbleNode.getRootNode()
            .children[0].name();
        var externalIdMapping = await getExternalIdMappingAsync(viewer.model);

        var links = new Object();

        var propsArr = await getAllPropertiesAsync(ids, viewer);

        for (var i = 0; i < ids.length; i++) {
            var props = propsArr[i];

            if (props == null) continue;
            this.properties[ids[i]] = props;
            this.idToAssignments[ids[i]] = [];

            var revitId = RevitIdFromProperties(props);

            var linkId = 0;
            var externalIds = props.externalId.split("/");
            var modelName = loadedModelName;

            if (revitId != null && externalIds.length > 1) {
                var linkInstanceId = externalIds[0];

                var dbId = externalIdMapping[linkInstanceId];

                if (links[dbId] == null)
                    links[dbId] = await getPropertiesAsync(dbId, viewer);
                var linkNameProp = links[dbId].properties.find(
                    (prop) =>
                        prop.displayName == "Type Name"
                );
                if (linkNameProp && linkNameProp.displayValue != null)
                    modelName = linkNameProp.displayValue;
                else modelName = "Unknown";

                linkId = RevitIdFromProperties(links[dbId]);
                if (linkId == null)
                    linkId = 0;
            }

            if (revitId == null)
                revitId = ids[i];

            this.keyToId[new ElementModelWbsId(revitId, modelName).GetKey()] = ids[i];
            var newId = new ElementModelId(linkId, revitId);
            this.viewerIdToModelId[ids[i]] = newId;
            this.modelIdToViewerId[modelIdToKey(newId)] = ids[i];
            

            this.modelsMap[ids[i]] = modelName;
        }


        if (projectId != null) {
            try {
                var bimSearchData = await getFromDb(projectId);

                var treeObj = JSON.parse(bimSearchData.wbsTree);

                for (var i = 0; i < treeObj.nodeDataArray.length; i++) {
                    this.wbs[treeObj.nodeDataArray[i].WBS.replaceAll(".", ",")] = treeObj.nodeDataArray[i];
                }

                var iter = 0;

                Object.keys(bimSearchData.elementsAssignment).forEach(wbs => {
                    Object.keys(bimSearchData.elementsAssignment[wbs]).forEach(id => {

                        var assignment = bimSearchData.elementsAssignment[wbs][id];

                        assignment.wbs = wbs;
                        var assignmentKey = ElementModelWbsId.fromModelId(assignment.id).GetKey();
                        var elementId = this.keyToId[assignmentKey];
                        if (elementId != null && this.idToAssignments[elementId] != null) {
                            this.idToAssignments[elementId].push(assignment);
                        }
                    });
                });

                bimSearchData.log.forEach(change => {
                    var changeKey = ElementModelWbsId.fromModelId(change.id).GetKey();
                    var modelId = this.keyToId[changeKey];
                    if (this.idToAssignments[modelId] != null)
                        this.idToAssignments[modelId].forEach(assignment => {
                            if (assignment.wbs == change.wbs) {
                                assignment.timestamp = change.timestamp;
                            }
                        });
                });

            }
            catch (err) {
                logError("FrontEnd.src.utils.builder.PropertiesManager.loadElements", err.toString());
            }
        }

    }

    GetProperties(id) {
        return this.properties[id];
    }

    GetModel(id) {
        return this.modelsMap[id];
    }

    GetWbsIds(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            res.push(assignment.wbs.replaceAll(",", "."));
        });
        return res.join();
    }

    GetWbsStates(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            res.push(ConstructionStateToString[assignment.state.currentState]);
        });

        if (res.length == 0)
            return "";

        return arrayToValue(res);
    }


    GetWbsReportParameters(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            if (this.wbs[assignment.wbs] != null)
                res.push(this.wbs[assignment.wbs].Report_Parameter);
        });

        if (res.length == 0)
            return "";
        return arrayToValue(res);
    }

    GetWbsAssignmentValues(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            res.push(assignment.assignmentValue);
        });

        if (res.length == 0)
            return 0;

        return arrayToValue(res);
    }

    GetWbsBillMonths(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            if (assignment.timestamp == null)
                res.push("___");
            else {
                var date = new Date(assignment.timestamp);
                res.push((date.getMonth() + 1) + "/" + date.getFullYear());
            }
        });

        if (res.length == 0)
            return "";

        return arrayToValue(res);
    }

    getWbsBillDate(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            if (assignment.timestamp == null)
                res.push("___");
            else {
                var date = new Date(assignment.timestamp);
                res.push((date.getDay() + 1) + "/" + (date.getMonth() + 1) + "/" + date.getFullYear());
            }
        });

        if (res.length == 0)
            return "";

        return arrayToValue(res);
    }

    GetWbsDescreptions(id) {
        var res = [];
        this.idToAssignments[id].forEach(assignment => {
            if (this.wbs[assignment.wbs] != null)
                res.push(this.wbs[assignment.wbs].Description);
        });
        return res.join();
    }
}

const IdsGetSize = 1000;

async function getAllPropertiesAsync(dbIds, viewer) {
    var resArr = [];
    for (var i = 0; i < dbIds.length; i += IdsGetSize) {
        var piece = dbIds.slice(i, i + IdsGetSize);
        var resPiece = await getBulkPropertiesAsync(piece, viewer);
        resArr.push(resPiece);
    }
    var res = resArr.flat();
    return res;
}


async function getBulkPropertiesAsync(dbIds, viewer) {
    return new Promise((resolve, reject) => {
        viewer.model.getBulkProperties(
            dbIds,
            null,
            result => resolve(result),
            error => reject(error)
        );
    });
}

// get properties of a model element from his viewer ID
async function getPropertiesAsync(dbId, viewer) {
    return new Promise((resolve, reject) => {
        viewer.getProperties(
            dbId,
            (result) => resolve(result),
            (error) => reject(error)
        );
    });
}

// Get id mappings for linked elements in model
async function getExternalIdMappingAsync(model) {
    return new Promise((resolve, reject) => {
        model.getExternalIdMapping(
            (map) => resolve(map),
            (error) => reject(error)
        );
    });
}

async function getFromDb(project) {
    var url = `/api/wbstrees?${currentUser.userId + "-" + project}`;
    var response = await fetch(url);
    var data = await response.json();

    return data;
}

function arrayToValue(arr) {
    if (arr.every(thing => thing === arr[0]))
        return arr[0];
    else {
        for (var i = 0; i < arr.length; i++) {
            if (!isNaN(arr[i]))
                arr[i] = +arr[i].toFixed(2);
        }
        return arr.join();
    }
}


/// <summary>
/// Those classes are the ones share with the server using json
/// any change here should be reflected at SharedClasses.cs
/// </summary>
class ElementModelWbsId {
    constructor(revitId, revitFileName, linkId = 0) {
        this.revitId = revitId;
        this.revitFileName = revitFileName;
        this.linkId = linkId;
    }

    static fromModelId(modelId) {
        return new ElementModelWbsId(modelId.revitId, modelId.revitFileName, modelId.linkId);
    }

    GetKey() {
        return this.revitFileName.split(".")[0] + "," + this.linkId + "," + this.revitId;
    }

    equals(other) {
        return this.revitId == other.revitId && this.revitFileName == other.revitFileName && this.linkId == other.linkId;
    }
}


function RevitIdFromProperties(props) {
    var res = props.name.split("[");
    if (res.length < 2)
        return null;
    var stringResult = res[1].split("]")[0];
    if (stringResult.toLowerCase().includes("e")) 
        return null;
    var result = +stringResult;
    return Number.isInteger(result) ? result : null;
}




const ConstructionStateToString = ["none", "hold", "progress", "done"];